import React, { useEffect } from 'react';

import { Box } from '@ublend-npm/aulaui-core';

import useBreakpoints from '@app/hooks/useBreakpoints';
import { useFlags } from 'launchdarkly-react-client-sdk';
import pushRoute from '@app/utils/routing';
import { AulaDispatch } from '@core/types/state';
import { useDispatch, useSelector } from 'react-redux';
import changeConversationOpen from '@core/conversations/operationsResponsive/changeConversationOpen.action';
import { getCurrentSpaceId } from '@core/selectors/space';
import CreateConversation from './CreateConversation';

const CreateConversationScreen = () => {
  const { lg } = useBreakpoints();

  const dispatch: AulaDispatch = useDispatch();
  const spaceId = useSelector(getCurrentSpaceId);
  const handleCreateConversationOpen = () => {
    dispatch(changeConversationOpen(true));
  };

  // This modal should be a separate page if the screen is too small
  // Redirect to messages and open modal
  useEffect(() => {
    if (lg) {
      pushRoute(`dashboard/${spaceId}/messages`);
      handleCreateConversationOpen();
    }
  }, [lg]);

  const { webAppFtResponsiveMessages202506 } = useFlags();
  if (!webAppFtResponsiveMessages202506) {
    pushRoute('/dashboard');
  }

  return (
    <Box sx={{ margin: 2 }}>
      <CreateConversation />
    </Box>
  );
};

export default CreateConversationScreen;
